module.exports = __webpack_public_path__ + "img/iconos-01.7f2cc4d1.svg";